import * as React from 'react';

import FormControl from '@mui/material/FormControl';
import _ from 'lodash';

import MultiSelect from 'src/components/MultiSelect';

export interface CallHistoryFilterProps {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
}
const CallHistoryFilter: React.FC<CallHistoryFilterProps> = ({ options, value, onChange }) => {
  const [tempValue, setTempValue] = React.useState<string[]>(value);

  return (
    <FormControl fullWidth>
      <MultiSelect
        label="Filters"
        placeholder="Add filter"
        getOptionLabel={(option) => _.startCase(option)}
        options={options}
        value={tempValue}
        onChange={setTempValue}
        onAccept={onChange}
      />
    </FormControl>
  );
};

export default CallHistoryFilter;
